module.exports = __webpack_public_path__ + "static/media/devops.f1927f81.jpg";